import React from 'react';

function Privacy() {
  return (
    <div className="min-h-screen">
      <div className="max-w-4xl mx-auto px-4 py-32">
        <h1 className="text-4xl font-bold text-white mb-8">Privacy Policy</h1>
        
        <div className="space-y-8 text-white/80">
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Information Collection and Use</h2>
            <p className="mb-4">
              We collect information to provide better services to our users and improve our business operations. The types of information we collect include:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Personal identification information (Name, email address, phone number, etc.)</li>
              <li>Business information</li>
              <li>Usage data and analytics</li>
              <li>Technical data (IP address, browser type, device information)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Data Protection</h2>
            <p className="mb-4">
              We implement appropriate data collection, storage, and processing practices and security measures to protect against unauthorized access, alteration, disclosure, or destruction of your personal information and data stored on our systems.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Information Sharing</h2>
            <p className="mb-4">
              We do not sell, trade, or rent users' personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information regarding visitors and users with our business partners, trusted affiliates, and advertisers.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Cookies and Tracking</h2>
            <p className="mb-4">
              Our website uses cookies and similar tracking technologies to track user activity and hold certain information to improve user experience. Users can control cookie settings through their browser preferences.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Third-Party Services</h2>
            <p className="mb-4">
              We may employ third-party companies and individuals to facilitate our service, provide service-related assistance, or assist us in analyzing how our service is used. These third parties have access to your personal information only to perform these tasks on our behalf.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">Updates to This Policy</h2>
            <p>
              We reserve the right to update this privacy policy at any time. We will notify users of any material changes by posting the new privacy policy on this page and updating the effective date.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Privacy;